import "./FileManagerCard.scss"
import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate,
    Fancybox, RAIKO_RATIOS, RaikoConfirmDialog,
    RaikoCustomTooltip,
    RaikoDivider, RaikoImageViewer,
    RaikoLabel,
    showErrorMessage, showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useState} from "react";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {FileManagerService} from "../fileManager/FileManagerService";
import {fileTypes} from "../fileManager/FileManager";
import RaikoVideoThumbnailGenerator
    from "../../pages/fileManager2/videoThumbnailGenerator/RaikoVideoThumbnailGenerator";
import audioIcon from "../../pages/fileManager2/images/ic_audio.svg";
import apkImage from "../../assets/svg/android_os.svg";
import {css} from "@emotion/css";
import {formatFileSize} from "../../util/fileSizeConvertor.ts";

export default function FileManagerCard(
    {
        id,
        name,
        url,
        streamUrl,
        size,
        uploadedAt,
        uploadedBy,
        type,
        isSelector = false,
        onClick,
        handleDeleteItemFromList
    }
) {
    const loading = new LoadingHelper(useLoadingDispatcher())

    const service = new FileManagerService()

    function getPreviewByType() {
        switch (type) {
            case fileTypes.IMAGE:
                return imagePreview()
            case fileTypes.APK:
                return apkPreview()
            case fileTypes.VIDEO:
                return videoPreview()
            case fileTypes.AUDIO:
                return audioPreview()
        }
    }

    function imagePreview() {
        return <div className={"imageContainer"}>
            <Fancybox
                options={{
                    Carousel: {
                        infinite: false,
                    },
                }}
            >
                <a href={url ? url.replace("http://", "https://") : ""} data-fancybox={"gallery"}
                   data-caption={` بارگزاری شده توسط ${uploadedBy} در تاریخ ${convertUniversalDateTimeToPersianDateTime(uploadedAt)}`}>

                    <RaikoImageViewer
                        title={name}
                        srcUrl={url ? url.replace("http://", "https://") : ""}
                        objectFit={"cover"}
                        aspectRatio={RAIKO_RATIOS.square}
                        width={"100%"}
                        height={"100%"}
                    />

                    <div className={css`z-index: 2`}>
                        <div className={"zoom_icon"}/>
                    </div>
                </a>
            </Fancybox>
        </div>;
    }

    function videoPreview() {
        return <div
            className={`videoPreviewContainer`}>
            <RaikoVideoThumbnailGenerator
                videoUrl={streamUrl ? streamUrl.replace("http:", "https:") : ""}
            />
        </div>
    }

    function audioPreview() {
        return <div className={"imageContainer"}>
            <img src={audioIcon} alt={name} className={css`padding: 1.5rem`}/>
        </div>
    }

    function apkPreview() {
        return <div className={"imageContainer"}>
            <img src={apkImage} alt={name} className={css`padding: .75rem`}/>
        </div>
    }

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);


    function handleDeleteDialog() {

        loading.show()
        service.deleteFile(id)
            .then(response => {
                showSuccessMessage("فایل با موفقیت حذف شد")
                setOpenDeleteDialog(false)
                handleDeleteItemFromList(id)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    return (

        <>
            <RaikoConfirmDialog
                openConfirmDialog={openDeleteDialog}
                cancelAction={_ => {
                    setOpenDeleteDialog(false)
                }}
                doAction={handleDeleteDialog}
                pageTitle={"حذف آیتم"}

            />
            <div
                className={`fileManagerCardLayout ${isSelector ? css`background: var(--color-surface) !important;` : ""}`}
                onClick={_ => {
                    if (isSelector) {
                        onClick()
                    }
                }}
            >
                <div className={"fileManagerCardImage"}>
                    <div
                        className={css`width: 100%;
                            position: relative;`}
                        onClick={event => {
                            event.stopPropagation()
                        }}>
                        {
                            getPreviewByType()
                        }

                        <div className={"fileManagerCardInfoContainer"}>
                            <div className={"dateContainer"}>
                                <div className={"ic-time"}/>
                                <span>{convertUniversalDateToPersianDate(uploadedAt)}</span>
                            </div>
                            <span className={"formatSizeContainer"}>{formatFileSize(size, {lang: 'fa'})}</span>
                        </div>
                    </div>
                </div>
                <div className={"fileManagerCardContentContainer"}>
                    <RaikoLabel text={name} className={css`font-size: var(--text-size-default)`}/>

                </div>
                <RaikoDivider/>
                <div className={"fileManagerCardAccessItemsContainer"}>
                    <a href={url} download={true} target={"_blank"} rel={"noreferrer"}>
                        <RaikoCustomTooltip title="دانلود">
                            <button className="btnAccess download-icon"/>
                        </RaikoCustomTooltip>
                    </a>
                    <RaikoCustomTooltip title="کپی لینک">
                        <button
                            onClick={_ => {
                                navigator.clipboard.writeText(url)
                                    .then(_ => {
                                        showSuccessMessage("لینک ویدیو با موفقیت کپی شد.")
                                    }).catch(_ => {
                                    showErrorMessage("خطا در کپی کردن لینک ویدیو!")
                                })
                            }}
                            className="btnAccess ic_share-link-icon"/>
                    </RaikoCustomTooltip>
                    <RaikoCustomTooltip title="حذف">
                        <button onClick={_ => {
                            setOpenDeleteDialog(true)
                        }} className="btnAccess ic_trash_version_one"/>
                    </RaikoCustomTooltip>
                </div>
            </div>
        </>

    )
}